import { combineEpics } from 'redux-observable';

import { route } from 'modules/mac/duck/actions/landing';

import { timeAction, counter } from './util';

export default combineEpics(
  counter(route.type, 'mac.licenses'),
  timeAction(route.type, 'mac.licenses'),
);
